import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { Row, Col, Container, Button } from 'react-bootstrap'
import { SelectInputNoForm } from '../../InputComponents'
import { TestDetails } from '../../../models/Sample'
import { BsDownload, BsUpload, BsVectorPen } from 'react-icons/bs'
import {  uploadPDFDataAsFile, downladPDFDataAsFile } from '../../../services'
import { AxiosResponse } from 'axios'
import { PDFViewer } from '../../PDFOperations'
import { AppUtil } from '../../../utils/app.utils'
import "react-pdf/dist/esm/Page/TextLayer.css";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { PRIVILEGES, MASTER_DATA_KEYS as MDK } from '../../../utils/constants'
import { AuthUtil } from '../../../utils/auth.utils'
import { MasterDataContext } from '../../../contexts'
import { getWorkflowReportDownloadURLs, getWorkflowReportUploadURLs, updateWorkflowReportStatus } from '../../../services/Workflow'
import { PDFSignModal } from '../../ViewSample/components/PDFSignModal'
import { WorkflowRequestPayload } from '../../../models/Workflow'
import * as _ from 'lodash'
import { SampleStatusMasterData } from '../../SampleInformationForm/helpers'
import { appRoutes } from '../../../utils/routes'

const translatReportTypess = 'reportTypes.'
const translatn = 'viewWorkflow.'
const parentClass = 'vcr-pp-view-pdf-container'

async function getPDFContent(pdfURL: string, setPdfData: any, setFailedpdfdata: any) {
  const response = await fetch(pdfURL)
  if (response.status == 200) {
    const pdfArrayBuffer = await response.arrayBuffer()
    const uint8ArrayPDFData = new Uint8Array(pdfArrayBuffer)
    setFailedpdfdata(false);
    setPdfData(uint8ArrayPDFData)
  }
  else {
    setPdfData(undefined)
    setFailedpdfdata(true);
  }
}

interface IReportURLMapObject {
  [key: string]: any
}

interface IReportsURLMapObject {
  [key: string]: IReportURLMapObject
}

interface IPPNMapObject {
  [key: string]: TestDetails
}

function getReportSelectOptions(t: any, translatReportTypess: string) {
  let reportOptions = Array()
  const reportNameMapObject: { [key: string]: string } = {}
  const reportsKeys = ['synopsisReport', 'overall_summary']

  for (const oneReportKey of reportsKeys) {
    reportNameMapObject[oneReportKey] = t(`${translatReportTypess}${oneReportKey}`)
    reportOptions.push({ 'reportKey': oneReportKey, 'reportValue': t(`${translatReportTypess}${oneReportKey}`) })
  }

  return { reportOptions: reportOptions, reportNameMapObject: reportNameMapObject, selectOptionKey: 'reportKey', selectOptionValue: 'reportValue' }
}

function createTestDataMap(sampleId: string, testDetails: any) {
  let ppnOptions = Array()
  const ppnMapObject: IPPNMapObject = {}

  for (const oneTestDetail of testDetails) {
    if (oneTestDetail?.status !== 'report_ready') continue
    ppnMapObject[oneTestDetail.ppn] = oneTestDetail
    ppnOptions.push(oneTestDetail.ppn)
  }
  return { ppnMapObject: ppnMapObject, ppnOptions: ppnOptions }
}

function getURLs(urlFunction: any, workflowId: any, urlMapObject: any, setReportsURLMapObject: any) {
  if (!workflowId) return
  urlFunction(String(workflowId)).then(
    (response: AxiosResponse) => {
      const singleReportURLsObject: IReportURLMapObject = {};
      const reportsURLMapObject: IReportsURLMapObject = structuredClone(urlMapObject);

      for (const singleReportsURL of response.data) {
        singleReportURLsObject[singleReportsURL.reportKey] = singleReportsURL
      }

      reportsURLMapObject[workflowId ?? ''] = singleReportURLsObject
      setReportsURLMapObject(reportsURLMapObject)
    },
    (error: any) => {
      AppUtil.logError(error)
    },
  )
}

function findReportStatus(signRequired: any, isSigned: any, isLocalSigned: string, selectedReportKey: string, selectedPPNValue: string, urlMapObject: any, setReportsURLMapObject: any) {
  let reportStatus = "not_signed"
  if (!signRequired) reportStatus = "sign_not_required"
  else if (signRequired && isSigned) reportStatus = "signed_and_uploaded"
  else if (signRequired && !isSigned) reportStatus = "not_signed"
  if (reportStatus === 'signed_and_uploaded') {
    reportStatus = "signed_and_uploaded"
    const reportsURLMapObject: IReportsURLMapObject = structuredClone(urlMapObject);
    reportsURLMapObject[selectedPPNValue][selectedReportKey].isSigned = true
    setReportsURLMapObject(reportsURLMapObject)

  }
  return reportStatus
}

const PPNDetails = ({ viewReports, workflow, setSelectedWorkflowInfo }: { viewReports: boolean, workflow: WorkflowRequestPayload, setSelectedWorkflowInfo: any }) => {

  const { id } = useParams()  
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { masterData } = useContext(MasterDataContext);

  const  splitString = (value: string) => {
    return value ? _.split(value, ',') : [];
  }

  const renderSampleIDs = () => {
    const sampleIDs: string[] = [...splitString(workflow.samples), ...splitString(workflow.draftSamples)]
    return sampleIDs?.map((sampleId:string, index:number)=>{
        return <a key={index} className={`${parentClass}-row-value`} style={{ cursor: 'pointer' }} onClick={() =>
                        navigate(
                          generatePath(appRoutes.viewSample, {
                            patientId: id,
                            id: sampleId,
                          }), { state: 'workflow'}
                        )
                      }>{sampleId}{sampleIDs.length - 1 !== index && ','}</a>
    })
  }

  return (
    <Row className={`${parentClass}-row`}>
      <Col className={`${parentClass}-col`}>
        <div className={`${parentClass}-row-label`}>{t(`${translatn}workflowName`)}</div>
        <div className={`${parentClass}-row-value`}>{AppUtil.getLabel(MDK.TEST_TYPE, masterData, workflow.workFlowId)}</div>
      </Col>
      <Col className={`${parentClass}-col`}>
        <div className={`${parentClass}-row-label`}>{t(`${translatn}sampleIds`)}</div>
        <div className={`${parentClass}-row-value`}>{renderSampleIDs()}</div>
      </Col>
      <Col className={`${parentClass}-col`}>
        {!viewReports && SampleStatusMasterData.sampleStatusValueMap.report_ready === workflow?.status && <a className={`${parentClass}-row-value`} style={{ cursor: 'pointer' }} onClick={() => setSelectedWorkflowInfo()}>View Reports</a>}
      </Col>
      <Col className={`${parentClass}-col m-4`}>
      </Col>
    </Row>
  )
}

type viewWorkflowPropsTypes = {
  workflow: WorkflowRequestPayload
}

export const ViewWorkflowDetails = (props: Readonly<viewWorkflowPropsTypes>) => {
  const { t } = useTranslation()
  const { id } = useParams()
  const { workflow } = props

  const [signModalShow, setSignModalShow] = useState(false)
  const [selectedReportKey, setSelectedReportKey] = useState("")
  const [viewReports, setViewReports] = useState<boolean>(false)
  const [reportLocalStatus, setReportLocalStatus] = useState<string>("not_signed")
  const [pdfBytesData, setPdfBytesData] = useState<Uint8Array | undefined>()
  const [resetPDFPageNumber, setResetPDFPageNumber] = useState<string>("no")
  const [reportsDownloadURLMapObject, setReportsDownloadURLMapObject] = useState<IReportsURLMapObject>({})
  const { ppnMapObject } = createTestDataMap(id ?? '', [])
  const { reportOptions, reportNameMapObject, selectOptionKey, selectOptionValue } = getReportSelectOptions(t, translatReportTypess)
  const [failedpdfdata, setFailedpdfdata] = useState(false)
  const [isCrcOrCrm, setIsCrcOrCrm] = useState<boolean>(false)

  const hasViewReportPrivilege = AuthUtil.checkUserAccess(PRIVILEGES.VIEW_QIAGEN_REPORT)
  const hasDownloadReportPrivilege = AuthUtil.checkUserAccess(PRIVILEGES.DOWNLOAD_QIAGEN_REPORT)
  const hasSignReportPrivilege = AuthUtil.checkUserAccess(PRIVILEGES.E_SIGN_REPORT)

  function updatePDFSignData(pdfData: Uint8Array) {
    setResetPDFPageNumber("no")
    setPdfBytesData(pdfData)
    setReportLocalStatus("signed")
  }

  function setSelectedWorkflowInfo() {
    setViewReports(true)

    getURLs(
      getWorkflowReportDownloadURLs,
      workflow.id ?? '',
      reportsDownloadURLMapObject,
      setReportsDownloadURLMapObject
    )
  }

  function setReportName(reportKey: string) {
    setSelectedReportKey(reportKey)
    if (reportKey) {
      setReportLocalStatus(findReportStatus(reportsDownloadURLMapObject?.[workflow.id ?? '']?.[reportKey]?.signRequired, reportsDownloadURLMapObject?.[workflow.id ?? '']?.[reportKey]?.isSigned, reportLocalStatus, reportKey, workflow.id?.toString() ?? '', reportsDownloadURLMapObject, setReportsDownloadURLMapObject))
      setIsCrcOrCrm(hasViewReportPrivilege && hasDownloadReportPrivilege && !hasSignReportPrivilege)
      setResetPDFPageNumber("reset")
      getPDFContent(reportsDownloadURLMapObject?.[workflow.id ?? '']?.[reportKey]?.path, setPdfBytesData, setFailedpdfdata)
    } else {
      setReportLocalStatus("not_signed")
      setFailedpdfdata(false)
      setIsCrcOrCrm(false)
      setResetPDFPageNumber("no")
      setPdfBytesData(undefined)
    }
  }

  function downloadPDFData() {
    downladPDFDataAsFile(reportNameMapObject[selectedReportKey] + '.pdf', pdfBytesData ?? new Uint8Array())
  }

  function uploadPDFData() {
    if (!pdfBytesData) return
    getWorkflowReportUploadURLs(String(workflow.id ?? '')).then(
      (response: AxiosResponse) => {
        const singleReportURLsObject: IReportURLMapObject = {};
        for (const singleReportsURL of response.data) {
          singleReportURLsObject[singleReportsURL.reportKey] = singleReportsURL
        }
        uploadPDFDataAsFile(singleReportURLsObject[selectedReportKey].path, pdfBytesData).then(
          () => {
            setReportLocalStatus("signed_and_uploaded")
            updateWorkflowReportStatus(String(workflow.id ?? ''), selectedReportKey, singleReportURLsObject[selectedReportKey].path, true).then(
              (res: any) => {
                reportsDownloadURLMapObject[workflow.id ?? ''][selectedReportKey].isSigned = true
                setReportsDownloadURLMapObject(reportsDownloadURLMapObject)
                /* getWorkflowReportUploadURLs(String(workflow.id ?? '')).then(
                  (response: AxiosResponse) => {
                    const singleReportURLsObject: IReportURLMapObject = {};
                    for (const singleReportsURL of response.data) {
                      singleReportURLsObject[singleReportsURL.reportKey] = singleReportsURL
                    }
                  },
                  (error: any) => {
                    AppUtil.logError(error)
                  },
                ) */
              }
            )
            

          },
          (error: any) => {
            AppUtil.logError(error)
          },
        )
      },
      (error: any) => {
        AppUtil.logError(error)
      },
    )
  }

  return (
    <Container className={`${parentClass}`} fluid>
      {signModalShow && <PDFSignModal show={signModalShow} handleClose={() => setSignModalShow(false)} pdfBytesData={pdfBytesData} reportName={reportOptions.find((report) => report.reportKey == selectedReportKey)?.reportValue} sampleID={workflow.samples ?? ''} testID={''} primaryTestTagID={workflow.workFlowId ?? ''} setpdfBytesData={updatePDFSignData} type={'workflow'}/>}

      <PPNDetails viewReports={viewReports} workflow={workflow} setSelectedWorkflowInfo={setSelectedWorkflowInfo} />

      {viewReports &&
        <><hr />

          <Row className={`${parentClass}-row`}>
            <Col lg={4} className={`${parentClass}-col`}>
              <div>
                <SelectInputNoForm
                  name={`reportName`}
                  id="reportName"
                  optionsValueArray={reportOptions}
                  optionKeyFieldName={selectOptionKey}
                  optionValueFieldName={selectOptionValue}
                  title={t(`${translatn}reports`)}
                  disabled={false}
                  required={false}
                  placeholder={t(`${translatn}reports`)}
                  onChange={(event: any) =>
                    setReportName(event.target.value.trim())
                  }
                  className={`${parentClass}-select-input`}
                  labelClassName={`${parentClass}-select-input-label`}
                />
              </div>
            </Col>
            {selectedReportKey && !failedpdfdata &&
              <Col className={`${parentClass}-action-col`}>
                {!isCrcOrCrm && <Col>
                  <Button
                    variant='link'
                    className={`${parentClass}-action-btn`}
                    size="sm"
                    name={`signReport`}
                    id="signReport"
                    title={t(`${translatn}signIconToolTip`)}
                    onClick={() => setSignModalShow(true)}
                    disabled={reportLocalStatus !== "not_signed"}
                  >
                    <BsVectorPen size={20} />
                  </Button>
                </Col>
                }
                {!isCrcOrCrm && <>
                  <span className={`${parentClass}-vertical-line`}></span>
                  <Col>
                    <Button
                      variant='link'
                      className={`${parentClass}-action-btn`}
                      size="sm"
                      name={`uploadReport`}
                      id="uploadReport"
                      title={t(`${translatn}uploadIconToolTip`)}
                      onClick={uploadPDFData}
                      disabled={reportLocalStatus !== "signed"}

                    >
                      <BsUpload size={20} />
                    </Button>
                  </Col>
                </>
                }
                {(reportLocalStatus === "signed_and_uploaded" || reportLocalStatus === "sign_not_required") && <>{(!isCrcOrCrm && <span className={`${parentClass}-vertical-line`}></span>)}
                  <Col>
                    <Button
                      variant='link'
                      className={`${parentClass}-action-btn`}
                      size="sm"
                      name={`downloadReport`}
                      id="downloadReport"
                      title={t(`${translatn}downloadIconToolTip`)}
                      onClick={downloadPDFData}
                    >
                      <BsDownload size={20} />
                    </Button>
                  </Col></>}
              </Col>
            }
          </Row></>
      }
      <Row className={`${parentClass}-details-row`}> {failedpdfdata && (<Col>{t(`${translatn}noReportIsAvailable`)}</Col>)}</Row>
      <Row className={`${parentClass}-details-row`}>
        <Col>
          {workflow.id && selectedReportKey && pdfBytesData && <PDFViewer resetPageNumber={resetPDFPageNumber} pdfData={pdfBytesData} />}
        </Col>
      </Row>
    </Container>
  )
}
